export interface OrderedColorSets {
  [key: string]: string[];
}
export const orderedColorsSets: OrderedColorSets = {
  1: ['#55e0d9'],
  2: ['#ff4a7a', '#58e8e0'],
  3: ['#ff4a7a', '#55a6ff', '#58e8e0'],
  4: ['#ff4a7a', '#a979be', '#55a6ff', '#58e8e0'],
  5: ['#ff4a7a', '#a879be', '#55a7ff', '#57c7f0', '#58e8e0'],
  6: ['#ff4a7a', '#b96fb0', '#7795e6', '#56b3f9', '#57cdec', '#58e8e0'],
  7: ['#ff4a7a', '#c669a7', '#8e88d3', '#55a6ff', '#56bcf5', '#57d2ea', '#58e8e0'],
  8: ['#ff4a7a', '#ce65a0', '#9d7ec6', '#6d99ec', '#56b0fb', '#56c2f1', '#57d5e9', '#58e8e0'],
  9: ['#ff4a7a', '#d4619b', '#a978bc', '#808fde', '#55a6ff', '#56b7f8', '#56c7ef', '#57d8e8', '#58e8e0'],
  10: [
    '#ff4a7a',
    '#d85e97',
    '#b373b5',
    '#8e87d3',
    '#689cf1',
    '#56aefc',
    '#56bcf5',
    '#57cbee',
    '#57d9e7',
    '#58e8e0',
  ],
  11: [
    '#ff4a7a',
    '#dd5c95',
    '#bb6fb0',
    '#9982ca',
    '#7794e5',
    '#55a6fe',
    '#56b3f9',
    '#56c0f2',
    '#57ceed',
    '#57dae6',
    '#58e8e0',
  ],
};

export const orderedColorsSetsReversed: OrderedColorSets = Object.keys(orderedColorsSets).reduce(
  (acc: OrderedColorSets, key) => {
    acc[key] = [...orderedColorsSets[key]].reverse();
    return acc;
  },
  {},
);
